import styled from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'

export const StepsContainer = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px 0;
  padding-top: ${(props) => (props.isCarrinhoWa ? '16px' : '0')};

  @media ${MOBILE_WIDTH} {
    max-width: 99%;
    overflow-x: auto;
    padding: ${(props) => (props.isMobile ? '10px' : '0')};
  }
`
